@if (loginForm$ | async; as form) {
  <form
    [ngrxFormState]="form"
    (submit)="onSubmit(form)"
    >
    <div>
      <div class="mb-4 text-center">
        <button
          class="btn btn-lg btn-primary"
          type="button"
          (click)="aadLogin(form)"
          >
          Login utenti Spedali Civili
        </button>
      </div>
      <div class="mb-4">
        <div class="d-flex">
          <div>
            <ellf-check-field [ngrxFormControlState]="form.controls.rememberMe">
            </ellf-check-field>
          </div>
          <div>Memorizzare la sessione?</div>
        </div>
      </div>
      <div ngbAccordion [closeOthers]="true">
        <div ngbAccordionItem>
          <h2 ngbAccordionHeader>
            <button ngbAccordionButton type="button">
              <h5 class="m-0">Login utenti esterni</h5>
            </button>
          </h2>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              <ng-template>
                @if ((userMustResetPassword$ | async) === false) {
                  <div>
                    <div class="mb-3">
                      <ellf-text-field
                        [label]="'Email'"
                        [ngrxFormControlState]="form.controls.username"
                        [errors]="form.controls.username.errors | ngrxFormsErr"
                        [shouldShowError]="form.controls.username.isInvalid && form.controls.username.isSubmitted"
                        >
                      </ellf-text-field>
                    </div>
                    <div class="mb-3">
                      <ellf-text-field
                        [label]="'Password'"
                        [controlType]="'password'"
                        [ngrxFormControlState]="form.controls.password"
                        [errors]="form.controls.password.errors | ngrxFormsErr"
                        [shouldShowError]="form.controls.password.isInvalid && form.controls.password.isSubmitted"
                        >
                      </ellf-text-field>
                    </div>
                  </div>
                }
                @if (userMustResetPassword$ | async) {
                  <div>
                    <div class="login-heitown mat-title">
                      Scegli la tua password
                    </div>
                    <div>
                      <ellf-text-field
                        [label]="'Password'"
                        [controlType]="'password'"
                        [ngrxFormControlState]="form.controls.newPassword"
                        [errors]="form.controls.newPassword.errors | ngrxFormsErr"
                        [shouldShowError]="form.controls.newPassword.isSubmitted"
                        >
                      </ellf-text-field>
                    </div>
                    <div>
                      <ellf-text-field
                        [label]="'Conferma Password'"
                        [controlType]="'password'"
                        [ngrxFormControlState]="form.controls.confirmPassword"
                        [errors]="form.controls.confirmPassword.errors | ngrxFormsErr"
                        [shouldShowError]="form.controls.confirmPassword.isSubmitted"
                        >
                      </ellf-text-field>
                    </div>
                    <div translate class="password-hint">
                      La password deve essere lunga 8 caratteri. <br />
                      Deve contenere maiuscole e minuscole. <br />
                      Deve contenere un numero. <br />
                      Deve contenere caratteri speciali.
                    </div>
                  </div>
                }
                <div class="mt-3 text-end">
                  <button type="submit" class="btn btn-primary">Login</button>
                </div>
                @if ((userMustResetPassword$ | async) === false) {
                  <div
                    class="mt-2 text-end"
                    >
                    <a
                      [routerLink]="['/auth/forgot-password']"
                      translate
                      class="forgot-link"
                      >Password dimenticata?</a
                      >
                    </div>
                  }
                  <div class="login-error text-danger text-end mt-3">
                    {{ loginError$ | ngrxPush }}
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  }
